import { httpService } from '../http.service.js'
import { utilService } from './../util.service.js'

const CACHE_EXPIRY_DAYS = 7 // זמן תוקף של הנתונים בלוקאל סטורג'
const CACHE_EXPIRY_TIME = CACHE_EXPIRY_DAYS * 24 * 60 * 60 * 1000 // זמן תוקף במילישניות
let cache = {} // קאש בזיכרון (RAM)

export const animeService = {
  fetchTopAnime,
}

// 📌 **משיכת האנימות הפופולריות מהשרת עם ניהול Cache חכם**
async function fetchTopAnime() {
  const cacheKey = 'topAnimeData'
  const cacheExpirationKey = 'topAnimeDataExpiration'
  const now = Date.now()

  // 🔹 1️⃣ קודם מחפשים ב-Cache בזיכרון (RAM)
  if (cache[cacheKey]) {
    return cache[cacheKey]
  }

  // 🔹 2️⃣ מחפשים ב-LocalStorage
  const cachedData = utilService.getFromLocalStorage(cacheKey)
  const cachedExpiration = utilService.getFromLocalStorage(cacheExpirationKey)

  if (cachedData && cachedExpiration && now < cachedExpiration) {

    // ✅ שומרים את הנתונים שוב ב-Cache (RAM) לשימוש מהיר יותר
    cache[cacheKey] = cachedData
    return cachedData
  }

  // 🔹 3️⃣ אם הנתונים לא זמינים, מבצעים בקשה לשרת
  const data = await fetchTopAnimeFromServer()

  if (data.length) {
    // ✅ שומרים את הנתונים בזיכרון (RAM)
    cache[cacheKey] = data

    // ✅ שומרים את הנתונים גם ב-LocalStorage
    utilService.saveToLocalStorage(cacheKey, data)
    utilService.saveToLocalStorage(cacheExpirationKey, now + CACHE_EXPIRY_TIME)
  }

  return data
}

// 📌 **משיכת האנימות הפופולריות מהשרת**
async function fetchTopAnimeFromServer() {
  const endpoint = 'animefeatures/popular' // ✅ הנתיב הנכון לשרת שלך

  try {
    const data = await httpService.get(endpoint)
    return data
  } catch (error) {
    console.error('❌ שגיאה במשיכת האנימות הפופולריות מהשרת:', error)
    return []
  }
}
